// Mock data for Homeshutter business website

export const businessInfo = {
  name: "Homeshutter",
  email: "enquiry@homeshutters.net",
  phone: "0435 986 052",
  logo: "https://customer-assets.emergentagent.com/job_shutter-solutions-2/artifacts/lootqxbr_Logo%20%282%29.png",
  location: "South Australia",
  serviceArea: "South Australia"
};

export const services = [
  {
    id: 1,
    title: "Roller Shutters",
    description: "Improve insulation, boost privacy, and keep your property secure—available in sleek designs to match your home's exterior.",
    image: "https://customer-assets.emergentagent.com/job_shutter-solutions-2/artifacts/0vd222sc_jfkWYrUC.jpeg",
    features: ["Custom-fitted", "Range of colours", "Professional installation", "Improved insulation"]
  },
  {
    id: 2,
    title: "Security Doors",
    description: "Tough, stylish, and built to last. Add an extra layer of protection without compromising on looks.",
    image: "https://customer-assets.emergentagent.com/job_shutter-solutions-2/artifacts/w2d9lpr5_Eqf8_Jo5.jpeg",
    features: ["Durable construction", "Stylish designs", "Extra protection", "Quality materials"]
  },
  {
    id: 3,
    title: "Repairs & Maintenance",
    description: "Got a jammed shutter or damaged door? We fix issues fast to keep your home or business safe.",
    image: "https://customer-assets.emergentagent.com/job_shutter-solutions-2/artifacts/z8acait1_Bvw2bvMp.jpeg",
    features: ["Fast repairs", "Expert maintenance", "Quick response", "Quality service"]
  },
  {
    id: 4,
    title: "Custom Fitting & Colours",
    description: "Every installation is measured precisely and tailored to your property. Choose from a variety of colours to suit your style.",
    image: "https://customer-assets.emergentagent.com/job_shutter-solutions-2/artifacts/63ojnxad_0UKs4fIK.jpeg",
    features: ["Precise measuring", "Custom tailored", "Multiple colours", "Professional fitting"]
  }
];

export const galleryImages = [
  {
    id: 1,
    title: "Black Roller Shutter & Security Door",
    image: "https://customer-assets.emergentagent.com/job_shutter-solutions-2/artifacts/pfh9gk3r_9tLOnZp_.jpeg",
    category: "Residential"
  },
  {
    id: 2,
    title: "Professional Security Door Installation",
    image: "https://customer-assets.emergentagent.com/job_shutter-solutions-2/artifacts/w2d9lpr5_Eqf8_Jo5.jpeg",
    category: "Security"
  },
  {
    id: 3,
    title: "Commercial Roller Shutters",
    image: "https://customer-assets.emergentagent.com/job_shutter-solutions-2/artifacts/xbecpr45_AcwylMC2.jpeg",
    category: "Commercial"
  },
  {
    id: 4,
    title: "Cream Bay Window Roller Shutters",
    image: "https://customer-assets.emergentagent.com/job_shutter-solutions-2/artifacts/k5trbfbz_ce_nDrTY.jpeg",
    category: "Residential"
  },
  {
    id: 5,
    title: "Large Window Roller Shutter",
    image: "https://customer-assets.emergentagent.com/job_shutter-solutions-2/artifacts/mpg50qdt_a6wCzsyv.jpeg",
    category: "Residential"
  },
  {
    id: 6,
    title: "Multiple Brown Roller Shutters",
    image: "https://customer-assets.emergentagent.com/job_shutter-solutions-2/artifacts/99ppbf93_tQ3KaLu5.jpeg",
    category: "Residential"
  },
  {
    id: 7,
    title: "Modern Grey House with Dark Roller Shutter",
    image: "https://customer-assets.emergentagent.com/job_shutter-solutions-2/artifacts/4cylsrhs_eMnW7unz.jpeg",
    category: "Residential"
  },
  {
    id: 8,
    title: "Dark Roller Shutter Detail",
    image: "https://customer-assets.emergentagent.com/job_shutter-solutions-2/artifacts/cuo3fcq8_O4UVn95y.jpeg",
    category: "Residential"
  },
  {
    id: 9,
    title: "Commercial Multiple Dark Shutters",
    image: "https://customer-assets.emergentagent.com/job_shutter-solutions-2/artifacts/nt8k9vg8_fwm-Kk3f.jpeg",
    category: "Commercial"
  },
  {
    id: 10,
    title: "Modern Brick House White Shutters",
    image: "https://customer-assets.emergentagent.com/job_shutter-solutions-2/artifacts/u08myztk_b8Ae8AMO.jpeg",
    category: "Residential"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah",
    location: "Glenelg",
    rating: 5,
    comment: "Professional, fast, and great quality. Highly recommend HomeShutters for anyone wanting to secure their home!",
    service: "Roller Shutters"
  },
  {
    id: 2,
    name: "David Thompson",
    location: "Adelaide",
    rating: 5,
    comment: "Excellent service from quote to installation. The shutters look fantastic and the team was very professional throughout.",
    service: "Security Doors & Shutters"
  },
  {
    id: 3,
    name: "Lisa Chen",
    location: "Adelaide Metro",
    rating: 5,
    comment: "Quick response for repairs and maintenance. Great to have a reliable local team who knows their stuff.",
    service: "Repairs & Maintenance"
  }
];

export const whyChooseUs = [
  {
    icon: "MapPin",
    title: "South Australia Local Team",
    description: "Local South Australian team with professional service across the state"
  },
  {
    icon: "Users",
    title: "Australian Manufactured Rollers",
    description: "Supporting local industry with premium Australian-made roller shutter products"
  },
  {
    icon: "Clock",
    title: "Fast Repairs",
    description: "Quick repairs and maintenance to keep your property secure"
  },
  {
    icon: "Award",
    title: "Custom Solutions",
    description: "Precise measuring and custom fitting with a range of colour options"
  }
];